window.addEventListener('DOMContentLoaded', () => {
    if ( document.querySelector(".accordeon-plus.foerg-accordeon") ) {
        const accordion = document.querySelector(".accordeon-plus.foerg-accordeon");
        accordion.addEventListener('click', change);
		function change(event) {
			let targ = event.target;
          	if ( targ.closest('h4') ) {
              let title = targ.closest('h4');
              if (title.classList.contains('select')) {
                  hideAll();
              } else {
                  hideAll();
                  title.classList.add('select');
                  let divTarg = title.nextElementSibling;
                  divTarg.classList.add('selected-block');
                  showText(divTarg.firstElementChild);
              }
            }
          }
		function hideAll() {
			var h4Titles = accordion.querySelectorAll('h4');
			var contentDivs = accordion.querySelectorAll('.accordeon_content');
            let wrapperBlocks = accordion.querySelectorAll('.block-wrapper');
			for ( let item of h4Titles ) {
				item.classList.remove('select');
			}
			for ( let item of contentDivs ) {
				item.style.height = '0';
              	item.classList.remove('selected-content');
			}
          	for ( let item of wrapperBlocks ) {
				item.classList.remove('selected-block');
			}
		}
		function showText(textEl) {
          
              	  console.log('firstElementChild', textEl.firstChild)
			textEl.style.height = textEl.scrollHeight + 'px';
          	textEl.classList.add('selected-content');
		}
  } else if ( document.querySelector(".foerg-accordeon") ) {
		const accordion = document.querySelector(".foerg-accordeon");
        accordion.addEventListener('click', change);
		function change(event) {
			let targ = event.target;
          	if ( targ.closest('h4') ) {
              let title = targ.closest('h4');
              if (title.classList.contains('select')) {
                  hideAll();
              } else {
                  hideAll();
                  title.classList.add('select');
                  showText(title.nextElementSibling);
              }
            }
          }
		function hideAll() {
			var h4Titles = accordion.querySelectorAll('h4');
			var contentDivs = accordion.querySelectorAll('.accordeon_content');
			for ( let item of h4Titles ) {
				item.classList.remove('select');
			}
			for ( let item of contentDivs ) {
				item.style.height = '0';
              	item.classList.remove('selected-content');
			}
		}
		function showText(textEl) {
         
			textEl.style.height = textEl.scrollHeight + 'px';
          	textEl.classList.add('selected-content');
		}
  }
});


	